import { Injectable } from '@angular/core';
import { CustomerIds, CustomerSettingsComponents } from "@shared/models/customer-settings";
import { UserService } from "@shared/services/user/user.service";
declare const L: any;

@Injectable({providedIn: 'root'})
export class CustomerSettingsService {

  customerId = 0;

  constructor(
    private userService: UserService
  ) {
    this.getCustomerInfo();
  }

  private getCustomerInfo(): void {
    this.userService.getUserInfo().subscribe(data => {
      this.customerId = data.customer_id;
    });
  }

  getCenterCoordinates(
    customerId: number,
    componentName: CustomerSettingsComponents,
  ): { latitude: number, longitude: number } {
    if (componentName === CustomerSettingsComponents.RoutePlanning) {
      switch (customerId) {
        case 1: return { latitude: 60.18208069645202, longitude: 23.97548906518469 };
        case 2: return { latitude: 60.03611032213076, longitude: 18.54047482522265 };
        case 3: return { latitude: 60.656023, longitude: 25.279696 };
        case 4: return { latitude: 62.1250521303749, longitude: 27.7926603631823 };
        default: return { latitude: 0, longitude: 0 };
      }
    }

    if (componentName === CustomerSettingsComponents.FieldReportingDashboard) {
      switch (customerId) {
        case 1: return { latitude: 60.18208069645202, longitude: 23.97548906518469 };
        case 2: return { latitude: 60.03611032213076, longitude: 18.55047482522265 };
        case 3: return { latitude: 60.656023, longitude: 25.279696 };
        case 4: return { latitude: 62.1250521303749, longitude: 27.7926603631823 };
        default: return { latitude: 0, longitude: 0 };
      }
    }

    return { latitude: 0, longitude: 0 }
  }
}
